export default function Section({ text }: { text: string }) {
    return (
        <div className="py-2 px-5 lg:px-7 bg-black rounded-lg mb-5 tracking-tighter">
            <p className="bg-green-text bg-clip-text text-transparent font-bold text-sm lg:text-base">
                {text}
            </p>
        </div>
    )
}